module.exports = __webpack_public_path__ + "img/gallery-3.b03a4ba3.webp";